export default "__VITE_ASSET__DVhp_YVa__";